module.exports = __webpack_public_path__ + "img/camera-yellow.2bbda003.svg";